import { Dayjs } from 'dayjs';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { EventDtoOriginEnum } from 'src/Services/API/generated';

export interface NavigableEvent {
  id: string;
  origin: EventDtoOriginEnum;
  isOccurrence: boolean;
}

const useEventNavigation = () => {
  const navigate = useNavigate();

  return useCallback(
    (event: NavigableEvent, occurrenceDate?: Dayjs) => {
      if (event.origin === EventDtoOriginEnum.External) return;

      const startTime =
        event.isOccurrence && occurrenceDate ? `?startTime=${occurrenceDate.toISOString()}` : '';

      switch (event.origin) {
        case EventDtoOriginEnum.Event:
          navigate(`event/${event.id}${startTime}`);
          return;
        case EventDtoOriginEnum.PracticalInformation:
          navigate(`practical-information/${event.id}`);
          return;
        case EventDtoOriginEnum.Project:
          navigate(`project/${event.id}`);
          return;
        case EventDtoOriginEnum.Task:
          navigate(`task/${event.id}`);
          return;
      }
    },
    [navigate]
  );
};

export default useEventNavigation;
